// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductInformer.module.scss  */
.ProductInformer-module-Root_3b9 {
  display: flex;
  align-items: center;
  column-gap: 8px;
  width: 100%; }

.ProductInformer-module-Link_bo9,
.ProductInformer-module-Text_1Cb {
  overflow: hidden;
  font-size: 14px;
  font-weight: normal;
  line-height: 21px;
  white-space: nowrap;
  text-overflow: ellipsis; }

.ProductInformer-module-Icon_1gr {
  flex-shrink: 0; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Product/Informer/ProductInformer.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW,EAAE;;AAEf;;EAEE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB,EAAE;;AAE3B;EACE,cAAc,EAAE","sourcesContent":["/*  imported from ProductInformer.module.scss  */\n.ProductInformer-module-Root_3b9 {\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n  width: 100%; }\n\n.ProductInformer-module-Link_bo9,\n.ProductInformer-module-Text_1Cb {\n  overflow: hidden;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 21px;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.ProductInformer-module-Icon_1gr {\n  flex-shrink: 0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
